import {
  Row,
  Col,
  Card,
  Descriptions,
} from "antd";

import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
} from "@ant-design/icons";

function About() {

  return (
    <>
      <div className="layout-content">
        <Row gutter={[24, 0]}>
          <Col span={24} md={12} xl={16} className="mb-24">
            <Card
              bordered={false}
              title={<h6 className="font-semibold m-0">About NPHL</h6>}
              className="header-solid h-full card-profile-information"
              bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
            >
              <p className="text-dark">
                {" "}
                National Public Health Laboratories (NPHL) is a public health facility comprising of several reference laboratory units 
                that provide referral services linking national, international and county laboratories.
                The NPHL is mandated to perform specialized testing for priority infectious and non-communicable diseases, laboratory-based disease surveillance,
                and to provide quality assurance for the public health laboratory network.
                While fulfilling its mandate of laboratory policy formulation and leadership,
                the NPHL ensures that its operation is within the management system requirements as prescribed by ISO 9000:2008.
                The NPHL also promotes quality laboratory systems as it provides national referral services to both public and private health sector
                {" "}
              </p>
              <hr className="my-25" />
              <Descriptions title="National Public Health Laboratories">
                <Descriptions.Item label="Full Name" span={3}>
                  NPHL Admin
                </Descriptions.Item>
                <Descriptions.Item label="Mobile" span={3}>
                  (+254) 123 123 123
                </Descriptions.Item>
                <Descriptions.Item label="Email" span={3}>
                  nphlict@nphl.go.ke
                </Descriptions.Item>
                <Descriptions.Item label="Location" span={3}>
                  Kenya
                </Descriptions.Item>
                <Descriptions.Item label="Social" span={3}>
                  <a href="#pablo" className="mx-5 px-5">
                    {<TwitterOutlined />}
                  </a>
                  <a href="#pablo" className="mx-5 px-5">
                    {<FacebookOutlined style={{ color: "#344e86" }} />}
                  </a>
                  <a href="#pablo" className="mx-5 px-5">
                    {<InstagramOutlined style={{ color: "#e1306c" }} />}
                  </a>
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
          {/* <Col span={24} md={12} xl={8} className="mb-24">
            <Card
              bordered={false}
              title={<h6 className="font-semibold m-0">Laboratories</h6>}
              className="header-solid h-full"
              bodyStyle={{ paddingTop: 0, paddingBottom: 16 }}
            >
              <List
                itemLayout="horizontal"
                dataSource={data}
                split={false}
                className="conversations-list"
                renderItem={(item) => (
                  <List.Item actions={[<Button type="link">Visit</Button>]}>
                    <List.Item.Meta
                      avatar={
                        <Avatar shape="square" size={48} src={item.avatar} />
                      }
                      title={item.title}
                      description={item.description}
                    />
                  </List.Item>
                )}
              />
            </Card>
          </Col> */}
        </Row>
      </div>
    </>
  );
}

export default About;
